import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPatch, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { JobType, UpdateJobTypeDto } from '@/types/settings';

interface UpdateJobTypeVariables {
  id: string;
  dto: UpdateJobTypeDto;
}

export const useUpdateJobType = createMutationHook<JobType, UpdateJobTypeVariables>({
  mutationFn: ({ id, dto }) =>
    apiPatch<JobType, UpdateJobTypeDto>(operationsClient, settingsEndpoints.jobType(id), dto),
  onSuccess: (_data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: settingsKeys.jobTypes() });
    toast.success('Job type updated');
  },
});
